'use client';
import type { Post } from '@/interfaces/post';
import uniq from 'lodash/uniq';
import { useState } from 'react';
import { Filter } from '../../../../components/filter';
import { PostPreview } from './post-preview';

type Props = {
  allPosts: Post[];
  isFrench: boolean;
};

export function Stories({ allPosts, isFrench }: Props) {
  const [category, setCategory] = useState('all');
  const allCategories = uniq(allPosts.map((post) => post.type));
  const filteredPosts =
    category === 'all'
      ? allPosts
      : allPosts.filter(
          (post) => post.type.toLowerCase() === category.toLowerCase(),
        );
  return (
    <>
      <div className="flex justify-between">
        <div className="flex">
          <Filter
            setCategory={setCategory}
            items={[
              { value: 'all', label: 'Tous' },
              ...allCategories.map((category) => ({
                value: category,
                label: category.charAt(0).toUpperCase() + category.slice(1),
              })),
            ]}
          />
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4 pt-6">
        {filteredPosts.map((post, index) => (
          <div key={index} className="grip gap-4">
            <PostPreview
              key={post.slug}
              title={isFrench ? post.title : post.title_en}
              coverImage={post.coverImage}
              date={post.date}
              author={post.author}
              slug={post.slug}
              excerpt={isFrench ? post.excerpt : post.excerpt_en}
              type={post.type}
            />
          </div>
        ))}
      </div>
    </>
  );
}
